import * as React from 'react'
import * as $ from 'jquery'
import {AjaxRequest} from "../lib/ajax";
import {CallJs} from "../lib/types";
import * as ReactDOM from "react-dom";
import {OwnProps, QueriesWidgetApp, Store} from "./queries-widget/app";
import {withDefault} from "../lib/utils";
import {applyMiddleware, createStore} from "redux";
import {reducer, State} from "./queries-widget/reducers";
import thunkMiddleware from "redux-thunk"
import {Query, QueryCategoryMap, QueryTitleMap} from "./queries-widget/data";
import {CategoryTreeItemCallJs, categoryFromCallJsCategory} from "../lib/category-manager/data";

// This function can be found /php/src/communications_html.php
declare function afterCommunicationRecipientList():void

export function getCommunicationRecipientList(page:string,messageId:number,hasSubscriptions:boolean) {
	const querySelections = $("input[name='selectedQueries']").val()

	const subSelections = !hasSubscriptions ? '' : $("input[name='subscriptions[]']:checked").map(
			function(this:HTMLInputElement) {
				return $(this).val()
			}
		).get().join()

	if (querySelections.length > 0) {
		$('#tempRecipientListDiv').attr('style', 'visibility: hidden;')
		$('#tempRecipientListLoadingDiv').attr('style', 'display: block; width: 300px; text-align: center;')
		const params = Object.assign(
			{
				command: 'createTempRecipientList',
				messageId: messageId,
				noheaders: 1,
				queries: querySelections
			},
			subSelections ? {subSelections: subSelections} : {}
		)
		new AjaxRequest(page).runGet<{}>(params).then(() => {
			afterCommunicationRecipientList()
		})
	}
}

type QueriesWidgetParams = {
	categories: CategoryTreeItemCallJs[]
	queries: QueryCallJs[]
	selectedQueries: (string|number)[]
	queryCategoryMap: QueryCategoryMapCallJs
}

type QueryCategoryMapCallJs = {[queryId: number]: (string|number)[]} & {[queryId: string]: (string|number)[]}

type QueryCallJs = {
	id: number|string
	instance: string
	title: string
	owner: string
}

const queryFromCallJsQuery = (q: QueryCallJs): Query => ({
	id: +q.id,
	instance: q.instance,
	title: q.title,
	owner: q.owner
})

const queryCategoryMapFromCallJsQueryCategoryMap = (map: QueryCategoryMapCallJs): QueryCategoryMap =>
	Object.keys(map).reduce((acc, k) => {
		acc[+k] = map[k].map(m => +m)
		return acc
	}, {} as QueryCategoryMap)

export const queriesWidget:CallJs<QueriesWidgetParams> = (replace, params) => {
	const queries = params.queries.map(queryFromCallJsQuery)
	const queryCategoryMap = queryCategoryMapFromCallJsQueryCategoryMap(params.queryCategoryMap)

	const ownProps = (store: Store): OwnProps => ({
		store: store,
		categories: params.categories.map(categoryFromCallJsCategory),
		queries,
		queryCategoryMap
	})

	const initialState: State = {
		selectedCategories: [],
		selectedQueries: params.selectedQueries,
		visibleQueries: queries.map(q => q.id),
		titleMap: titleMap(queries)
	}

	const div = document.createElement('div')
	replace(div)

	const store = createStore(withDefault(reducer(queries, queryCategoryMap), initialState), initialState, applyMiddleware(thunkMiddleware))
	ReactDOM.render(<QueriesWidgetApp {...ownProps(store)}/>, div)
}

const titleMap = (queries: Query[]) => {
	return queries.reduce((acc, v) => {
		const instance = v.instance != '' ? v.instance + ": " : ''
		const owner = v.owner != '' ? ` (Owner: <strong>${v.owner}</strong>)` : ''
		acc[v.id] = `${instance}${v.title}${owner}`
		return acc
	}, {} as QueryTitleMap)
}



// WEBPACK FOOTER //
// ./src/communications/message.tsx